import { Collection, Plugin } from 'ckeditor5';
/**
 * This plugin is responsible for managing the state of the condition plugin.
 * It will keep track of all conditions in the editor and provide methods for
 * adding, removing and getting conditions.
 */
export class ConditionState extends Plugin {
    constructor() {
        super(...arguments);
        this.conditionData = new Collection();
    }
    static get pluginName() {
        return 'ConditionState';
    }
    init() {
        this.set('activeCondition', undefined);
    }
    addCondition(id) {
        if (!id) {
            return;
        }
        const exists = this.conditionData.has(id);
        if (exists) {
            return;
        }
        this.conditionData.add({
            id,
        });
    }
    getCondition(id) {
        if (!id) {
            return null;
        }
        return this.conditionData.get(id);
    }
    removeCondition(id) {
        this.conditionData.remove(id);
    }
}
